import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/api/apiClient";
import { useAuth } from "@/contexts/AuthContext";
import type { RefereePendingBonusResponse } from "@shared/schemas/api";

/**
 * Referee-side: fetches whether the signed-in user has a pending referral whose
 * bonus unlocks when they subscribe to a paid plan. Drives ReferralBonusBanner.
 * Amounts come from the server (single source of truth) — never hardcoded here.
 */
export function useReferralBonusBanner(): RefereePendingBonusResponse | undefined {
  const { user } = useAuth();

  const { data } = useQuery<RefereePendingBonusResponse>({
    queryKey: ["referral-pending", user?.id],
    queryFn: () => apiGet<RefereePendingBonusResponse>("/api/referral/pending"),
    enabled: !!user,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return data;
}
